import { Component, Injector } from '@angular/core';
import { FileDto } from '../base-types';
import { FormSettings } from '../forms/form-settings';
import { FormComponent } from '../forms/form.component';

@Component({
  selector: 'app-importer',
  templateUrl: './importer.component.html',
  styleUrls: ['./importer.component.scss']
})
export class ImporterComponent extends FormComponent {

  private _reloadedItem: any;

  constructor(protected _injector: Injector) { 
    super(_injector);
  }

  async ngOnInit() {
    await super.init()
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        file: { required: true }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    this._reloadedItem = {}

    return this._toForm(this._reloadedItem);
  }
  
  /** @override */
  protected async _submitHook() {
    
  }

  private  _toForm = (dto: any): { [key: string]: number | string | boolean | (string | number)[] | File | File[] } => {
    let result: { [key: string]: number | string | boolean | (string | number)[] | File | File[] } = {}
    result.firstName = dto.firstName;
    return result;
  }
}

